import styled, { keyframes } from "styled-components";
import { connect } from "react-redux";
import React, { useState } from 'react';
import { EnvelopeSimpleOpen } from "@phosphor-icons/react";

import { loginWithEmailAndPassword, loginWithVnkId, sendPasswordResetEmail } from "../../store/actions";
import { validate } from "../Shared/inputValidator";
import { Button, Field, Label, TextLink } from "../Shared/ui";

const Email = (props) => {

  const [vnkId, setVnkId] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [showOption, setShowOption] = useState('login');
  const [forgotEmail, setForgotEmail] = useState('');

  const handleVnkIdChange = (event) => {
    setVnkId(event.target.value);
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  }

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  }

  const loginClick = (event) => {
    event.preventDefault();
    if(email === '' && vnkId!== '') {
      props.loginWithVnkId(vnkId.trim(), password.trim());
    } else if(email !== '') {
      props.loginWithEmailAndPassword(email.trim(), password.trim());
    }
  }

  const handleForgotEmailChange = (event) => {
    setForgotEmail(event.target.value);
  }

  const resetPasswordClick = (event) => {
    event.preventDefault();
    if(validate(["forgotEmail"])) {
      props.sendPasswordResetEmail(forgotEmail);
    }
  }

  const forgotPasswordClick = () => {
    setShowOption('password');
  }

  const loginLinkClick = () => {
    setShowOption('login');
  }

  return (
    <div>
      {showOption === 'login' &&
        <Pane as="form" key="login" onSubmit={ loginClick } noValidate>
          <Title id="login-title">Welcome back</Title>
          <Sub>Log in with your VNK ID or your email address.</Sub>
          <Field>
            <Label htmlFor="vnkId">VNK ID</Label>
            <input
              id="vnkId"
              type="text"
              name="vnkId"
              autoComplete="username"
              value={ vnkId }
              onChange= { handleVnkIdChange }/>
          </Field>
          <Divider><span>or</span></Divider>
          <Field>
            <Label htmlFor="email">Email address</Label>
            <input
              id="email"
              type="email"
              name="email"
              autoComplete="email"
              value={ email }
              onChange= { handleEmailChange }
            />
          </Field>
          <Field>
            <Label htmlFor="password">Password</Label>
            <input
              id="password"
              type="password"
              name="password"
              autoComplete="current-password"
              value= { password }
              onChange= { handlePasswordChange }
            />
          </Field>
          <Button type="submit" $block>Log in</Button>
          <Footer>
            <TextLink type="button" onClick = { forgotPasswordClick }>Forgot password?</TextLink>
          </Footer>
        </Pane>
      }
      {showOption === 'password' &&
        <Pane as="form" key="password" onSubmit={ resetPasswordClick } noValidate>
          <Title id="login-title">Reset your password</Title>
          { !props.resetPasswordStatus &&
            <>
              <Sub>Enter the email address you registered with and we'll send you a reset link.</Sub>
              <Field>
                <Label htmlFor="forgotEmail">Email address</Label>
                <input
                  id="forgotEmail"
                  type="email"
                  name="forgotEmail"
                  autoComplete="email"
                  value={ forgotEmail }
                  data-error-message="Email format not valid"
                  data-error-type="email"
                  onChange= { handleForgotEmailChange }
                />
              </Field>
              <Button type="submit" $block>Send reset link</Button>
            </>
          }
          { props.resetPasswordStatus &&
            <Success role="status">
              <EnvelopeSimpleOpen size={36} weight="duotone" />
              <span>We have shared a password reset link to <strong>{forgotEmail}</strong>. Please use the link to reset your password.</span>
            </Success>
          }
          <Footer>
            <TextLink type="button" onClick = { loginLinkClick }>Back to log in</TextLink>
          </Footer>
        </Pane>
      }
    </div>
  );
};

const swap = keyframes`
  from { opacity: 0; transform: translateX(12px); }
  to { opacity: 1; transform: none; }
`;

const Pane = styled.div`
  animation: ${swap} 0.45s var(--ease-out) both;
`;

const Title = styled.h2`
  font-size: 28px;
  margin: 0 48px 6px 0;
`;

const Sub = styled.p`
  color: var(--text-muted);
  font-size: 15px;
  margin-bottom: 24px;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 4px 0 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-muted);

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: var(--border);
  }
`;

const Footer = styled.div`
  margin-top: 18px;
  text-align: center;
  font-size: 15px;
`;

const Success = styled.div`
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 18px;
  margin: 8px 0 4px;
  border-radius: 16px;
  background: var(--surface-butter);
  line-height: 1.55;

  svg {
    flex: none;
    color: var(--coral);
  }
`;

const mapStateToProps = (state) => {
  return {
    resetPasswordStatus: state.userState.resetPasswordStatus,
  };
};

const mapDipatchToProps = (dispatch) => ({
  loginWithEmailAndPassword: (email, password) => dispatch(loginWithEmailAndPassword(email, password)),
  loginWithVnkId: (vnkId, password) => dispatch(loginWithVnkId(vnkId, password)),
  sendPasswordResetEmail: (email) => dispatch(sendPasswordResetEmail(email)),
});

export default connect(mapStateToProps, mapDipatchToProps)(Email);
